import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
// import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Accordin from '../../components/accordinIncorporation';
// import AddAdditional from './addAdditional/index2';
import CheckListFooter from '../../components/checkListFooterIncorporation';
// import ProgressNav from './progressNav';
import './styles.css';
import CheckListFooterIncorporation from '../../components/checkListFooterIncorporation';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '2%',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    pos: {
        marginBottom: 12,
    },
    cardCustom: {
        padding: '0',
    },
    fullWidth: {
        width: '100%',
        // marginTop: '5%',
        // position: 'fixed',
        left: '0',
        bottom: '0',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
}));

export default function CheckListGenerator(props) {
    const classes = useStyles();
    const [page, setPage] = useState(1);
    const bull = <span className={classes.bullet}>•</span>;
    const history = useHistory();

    const navigate = () => {
        //console.log();
        props.history.push('/menu/addAdditional');
    };

    return (
        <div className="smlmt-15">
            {/* <ProgressNav pageNo={page} /> */}
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <CardHeader
                        className="borderBottomLine"
                        // action={
                        // <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                        //     Add Additional Questions
                        // </Button>
                        // }
                        title="Incorporation Flow"
                    />

                    <Accordin />
                </CardContent>
                {/* <CardActions>
                <Button size="small">Learn More</Button>
            </CardActions> */}
            </Card>
            <Grid item sm={12} className={classes.fullWidth} style={{ paddingLeft: '0' }}>
                <CheckListFooterIncorporation />
            </Grid>
        </div>
    );
}
